/*
 * @Author: luyaj 1579618152@qq.com
 * @Date: 2025-04-10 10:34:22
 * @LastEditors: luyaj 1579618152@qq.com
 * @LastEditTime: 2025-04-17 18:20:30
 * @FilePath: \my-vue-project\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'

// 1. 创建实例 
const service = axios.create({
  baseURL: '/hzarts',
  timeout: 5000,
})

// 2. 请求拦截器 
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 3. 响应拦截器 
service.interceptors.response.use(
  response => {
    // 统一处理业务状态码 
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

export const getAction = async (url, params) => {
  try {
    const response = await service.get(url, { params });
    return response;
  } catch (error) {
    console.error('GET request failed:', error);
    throw error;
  }
};

export const postAction = async (url, data) => {
  try {
    const response = await service.post(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (error) {
    console.error('POST request failed:', error);
    throw error;
  }
};